var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5789 2.00195H4.47368C3.66316 2.00195 3 2.6565 3 3.4565V12.911C3 13.311 3.33158 13.6383 3.73684 13.6383C4.14211 13.6383 4.47368 13.311 4.47368 12.911V4.18377C4.47368 3.78377 4.80526 3.4565 5.21053 3.4565H12.5789C12.9842 3.4565 13.3158 3.12923 13.3158 2.72923C13.3158 2.32923 12.9842 2.00195 12.5789 2.00195ZM13.0137 5.3401L16.5726 8.85283C16.8452 9.12192 17 9.49283 17 9.87828V16.5474C17 17.3474 16.3368 18.0019 15.5263 18.0019H7.41366C6.60313 18.0019 5.94735 17.3474 5.94735 16.5474L5.95471 6.36556C5.95471 5.56556 6.6105 4.91101 7.42103 4.91101H11.9673C12.3579 4.91101 12.7337 5.06374 13.0137 5.3401ZM12.5789 10.002H15.8947L11.8421 6.00195V9.27468C11.8421 9.67468 12.1737 10.002 12.5789 10.002Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/Download-icon.ff433a84b1b095b5d3caa9a4ca8298de.svg";
export { ForwardRef as ReactComponent };